var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.6 5.7c.4-.4.4-1 0-1.4a1 1 0 0 0-1.4 0L12 10.6 5.7 4.3a1 1 0 0 0-1.4 0 1 1 0 0 0 0 1.4l6.2 6.3-6.2 6.2a1 1 0 0 0 0 1.5c.4.4 1 .4 1.4 0l6.3-6.3 6.2 6.3c.4.4 1 .4 1.4 0s.4-1 0-1.5L13.4 12z",
    clipRule: "evenodd"
  })));
};
export default SvgClose;